import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const HeaderSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const ActionArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const TableSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
